import { writable } from 'svelte/store';
export const user = writable(null);
export const timelines = writable([]);
export const selectedTimeline = writable(null);
export const events = writable([]);
// update events when the timelines get updated or the user selects a different timeline
let selectedId;
selectedTimeline.subscribe(value => {
    var _a, _b;
    events.set((_a = value === null || value === void 0 ? void 0 : value.data) === null || _a === void 0 ? void 0 : _a.events);
    selectedId = (_b = value === null || value === void 0 ? void 0 : value.ref) === null || _b === void 0 ? void 0 : _b.id;
});
timelines.subscribe((value) => {
    if (selectedId) {
        const refreshedSelected = value.find(timeline => timeline.ref.id === selectedId);
        selectedTimeline.set(refreshedSelected);
    }
    else {
        selectedTimeline.set(value[0]);
    }
});
